function setThumbImage() {
  var thumbNum;
  var imageid;
  $(document).on("click", ".js-change-thumb", function() {
    thumbNum = $('.js-change-thumb').index($(this));
    imageid = $('.imageid').eq(thumbNum).val();
    $('.js-thumbs-list li').removeClass('active');
    $('.js-thumbs-list li').each(function() {
      if ($(this).data('imageid') == imageid) {
        $(this).addClass('active');
        return false;
      }
    });
  });

  $(document).on("click", ".js-thumb-image-remove", function() {
    $(this).next().val('');
    $(this).parent().addClass('noimage');
  });

  $(document).on("click", ".js-thumbs-list li", function() {
    if ($(this).hasClass('active')) {
      return false;
    }
    // $('.js-thumbs-list li').removeClass('active');
    // $(this).addClass('active');
    imageid = $(this).data('imageid');

    $(".changeable-image").removeClass('noimage');
    $(".imageid").eq(thumbNum).val(imageid);
    // var src = '/static/website/images/message/'+ imageid +'.jpg';
    var src = $(this).find('img').data('src');
    $(".js-thumb-image").eq(thumbNum).attr('src', src);

    hideModal();
  });
}

if ($(".js-change-thumb").length > 0) {
  setThumbImage();
}

function hideModal() {
  $('#js-modal-bg').fadeOut(150);
  $('.modal').removeClass('show2');
  $('.modal').removeClass('show');
}
